var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.dropdownCls},[_c('span',{class:_vm.labelCls,style:(_vm.labelStyle),on:{"click":_vm.toggle}},[_vm._v("\n    "+_vm._s(_vm.label)+"\n    "),_c('i',{staticClass:"effect-dropdown__label-caret effect-dropdown-iconfont"})]),_vm._v(" "),_c('ul',{staticClass:"effect-dropdown__content"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c46143ee","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EffectDropdown.vue
// module id = 22
// module chunks = 0